/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.



  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    var sizeselector = document.querySelector('[data-select-label="Size"]');
    var customForm = document.getElementById('custom_size_form');
    var customFormInputs = customForm.querySelectorAll('input');
    var customFormLabels = customForm.querySelectorAll('label');
    var messageElement = document.querySelector('.variant_message');
    var custom_image = document.querySelector('.custom_image')
    
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
      if (variant.title.includes('MADE TO ORDER') || variant.title.includes('Made To Order') || variant.title.includes('made to order')) {
        customForm.removeAttribute('hidden');
        console.log("Showing custom form", event);
        
      }
      else {
        customForm.setAttribute('hidden', true);
        console.log("Hiding Form", event);
        custom_image.style.display = 'none';
        customFormInputs.forEach(element => {
          element.value = "";     
        });
        customFormLabels.forEach(element => {
          element.classList.remove('label--float');
        });
      }
      // Variant message update
      if (messageElement) {
        var mtoText = messageElement.getAttribute('data-mto');
        var rtsText = messageElement.getAttribute('data-rts');
        const form = document.querySelector('form[action*="/cart/add"]');
        const addToCartBtn = form?.querySelector('[type="submit"]');
  
        if (variant.title.toLowerCase().includes('made to order')) {
          messageElement.textContent = mtoText;
          custom_image.style.display = 'none';
          addToCartBtn.disabled = true;
        } else {
          messageElement.textContent = rtsText;
          custom_image.style.display = 'block';
          addToCartBtn.disabled = false;
        }
      }
      
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form[action*="/cart/add"]');
  const addToCartBtn = form?.querySelector('[type="submit"]');
  const customForm = document.getElementById('custom_size_form');

  if (!form || !addToCartBtn || !customForm) return;

  // Get only visible inputs with min/max attributes
  const getCustomInputs = () => {
    return [...customForm.querySelectorAll('input[type="number"]')].filter(input => {
      return input.hasAttribute('min') || input.hasAttribute('max');
    });
  };

  const validateCustomInputs = () => {
    if (customForm.hasAttribute('hidden')) {
      addToCartBtn.disabled = false;
      return true;
    }

    let valid = true;
    const inputs = getCustomInputs();

    inputs.forEach(input => {
      const value = parseFloat(input.value);
      const min = input.hasAttribute('min') ? parseFloat(input.min) : -Infinity;
      const max = input.hasAttribute('max') ? parseFloat(input.max) : Infinity;

      if (isNaN(value) || value < min || value > max) {
        valid = false;
      }
    });

    addToCartBtn.disabled = !valid;
    return valid;
  };

  // Real-time validation
  getCustomInputs().forEach(input => {
    input.addEventListener('input', validateCustomInputs);
  });

  // On submit
  addToCartBtn.addEventListener('click', function (e) {
    if (!validateCustomInputs()) {
      e.preventDefault();
      alert("Please ensure all size inputs are within allowed limits.");
    }
  });

  // Initial check
  validateCustomInputs();
});




  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  
})();



